import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inputError',
})
export class InputErrorPipe implements PipeTransform {
  transform(value: any): string {
    if (!value || typeof value !== 'object') {
      return '';
    }

    const errorKeys = Object.keys(value);
    if (errorKeys.length === 0) {
      return '';
    }

    const key = errorKeys[0] === 'required' ? errorKeys[errorKeys.length - 1] : errorKeys[0];

    switch (key) {
      case 'required':
        return 'Field is required.';
      case 'matDatepickerMin':
        return 'The date can not be in the past.';
      case 'matDatepickerMax':
        return 'Must be within 5 years.';
      case 'matDatepickerParse':
        return 'Must be mm/dd/yyyy.';
      case 'pattern':
        return 'Must be a number.';
      case 'invalidOdometer':
        return `Can not be lower than ${formatNumber(Number(value[key]), 'en-US', '1.0-0')}.`;
      case 'email':
        return 'Must be a valid email.';
      case 'minlength':
        return 'Does not meet minimum length.';
      case 'maxlength':
        return 'Exceeds maximum length.';
      case 'vehicleExists':
        return 'This vehicle already exists.';
      case 'invalidWorkOrderId':
        return 'Work Order ID is invalid.';
      case 'invalidPhoneNumber':
        return 'Please enter a valid phone number.';
      case 'invalidEmailAddress':
        return 'Please enter a valid email address.';
      case 'invalidPhoneNumberLength':
        return 'Must be a 10-digit phone number.';
      case 'addressSelectionRequired':
        return 'Choose an address from the list.';
      default:
        return 'Field is required.';
    }
  }
}
